/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Accessdenied1Inputs */

const he_common_accessdenied1 = /** @type {(inputs: Common_Accessdenied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גישה נדחתה`)
};

const en_common_accessdenied1 = /** @type {(inputs: Common_Accessdenied1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Denied`)
};

/**
* | output |
* | --- |
* | "Access Denied" |
*
* @param {Common_Accessdenied1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_accessdenied1 = /** @type {((inputs?: Common_Accessdenied1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Accessdenied1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_accessdenied1(inputs)
	return en_common_accessdenied1(inputs)
});
export { common_accessdenied1 as "common_accessDenied" }